/**
 * Valeurs affichées dans le comparateur santé (CAS) — tableau, tarification.
 * Alignées sur l’écran commissionnement (une seule liste).
 */
export const CAS_COMMISSION_LIST = [
  '45/10',
  '40/10',
  '40/15',
  '38/13',
  '35/10',
  '35/12',
  '30/10',
  '15/15',
  '10/10',
  '00/00'
];

/**
 * Normalise vers le format canonique X/Y (ex. 1515 → 15/15, 4010 → 40/10).
 */
export function normalizeCasCommission(raw: string | undefined): string | undefined {
  if (!raw) return undefined;
  const s = raw.toString().trim();

  const slashMatch = s.match(/^(\d{2,3})\s*[/\\]\s*(\d{2,3})[A-Za-z]*$/);
  if (slashMatch) {
    const canonical = `${slashMatch[1]}/${slashMatch[2]}`;
    return canonical;
  }

  const colledMatch = s.match(/^(\d{2,3})(\d{2})$/);
  if (colledMatch) {
    return `${colledMatch[1]}/${colledMatch[2]}`;
  }

  const spaceMatch = s.match(/^(\d{2,3})\s+(\d{2,3})$/);
  if (spaceMatch) {
    return `${spaceMatch[1]}/${spaceMatch[2]}`;
  }

  const letterMatch = s.match(/^(\d{2,3})[A-Za-z]*\s*[/\\]\s*(\d{2,3})[A-Za-z]*$/);
  if (letterMatch) {
    return `${letterMatch[1]}/${letterMatch[2]}`;
  }

  return s;
}
